import styled from 'styled-components'

import theme from 'style/theme'

export default styled.div`
  background-color: ${theme.white};
  border-radius: 10px;
  padding: 10px 20px;
  box-shadow: 0 -1px 15px 0 rgba(0, 0, 0, 0.14);
  display: flex;
  justify-content: center;
  align-items: center;

  .bar-step-block {
    width: 100%;
    margin-left: 16px;

    .bar-step {
      position: relative;
      height: 5px;
      width: 100%;
      background-color: ${theme.lightGray};
      border-radius: 10px;
      overflow: hidden;
      margin-top: 5px;

      .active-bar-step {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        border-radius: 10px;
        background-color: ${theme.primaryRed};
      }

      .max {
        background-color: ${theme.lightGreen};
      }
    }
  }
`
